import { Page } from '@/core/architecture'

import { LotteryApplicationsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryApplications Page
 * Implemented as a practical sample.
 */
export const LotteryApplications: Page = () => {
  const { state, actions } = useViewModel()

  return <LotteryApplicationsTemplate state={state} {...actions} />
}
